<script>
// Check out link generators:
// * https://play.google.com/intl/en_us/badges/
// * https://linkmaker.itunes.apple.com/ru-ru/details/1494877615
const SimpleAppLink = ({ props }) => (
  <a
    target="_blank"
    href={props.url}
  >
    <img
      alt={props.altText}
      src={props.icon}
      class="app-links__image"
    />
  </a>
)

export default ctx => {
  const apps = ctx.parent.$store.state.store.store.settings.applications;
  const appStoreUrl = apps.app_store.url;
  const googlePlayUrl = apps.google_play.url;
  return (
    <ul class="app-links">
      {
        appStoreUrl &&
        <li class="app-links__item">
          <SimpleAppLink
            url={appStoreUrl}
            alt-text="Загрузите в App Store"
            icon={require('@/assets/images/icons/app-store-badge-ru.svg')}
          />
        </li>
      }
      {
        googlePlayUrl &&
        <li class="app-links__item">
          <SimpleAppLink
            url={googlePlayUrl}
            alt-text="Доступно в Google Play"
            icon={require('@/assets/images/icons/google-play-badge-ru-cropped.png')}
          />
        </li>
      }
    </ul>
  )
} 
</script>

<style lang="less">
.app-links {
  &__item {
    line-height: 0;
    &:not(:first-child) {
      @apply mt-4;
    }
    > a {
      @apply inline-block;
    }
  }
  &__image {
    width: 135px;
  }
}
</style>
